var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","right-text":""}}),_c('HotComments',{attrs:{"slug":_vm.slug,"limit":0},on:{"gotHotComments":_vm.gotHotComments}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }